var _rect;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgYellowSquareTilted = function SvgYellowSquareTilted(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 80.757,
    height: 80.757
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rectangle 122",
    width: 64.152,
    height: 64.152,
    rx: 3,
    transform: "rotate(-17.89 62.601 9.854)",
    fill: "rgba(255,222,140,0.2)"
  })));
};
export { SvgYellowSquareTilted as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI4MC43NTciIGhlaWdodD0iODAuNzU3IiB2aWV3Qm94PSIwIDAgODAuNzU3IDgwLjc1NyI+DQogIDxyZWN0IGlkPSJSZWN0YW5nbGVfMTIyIiBkYXRhLW5hbWU9IlJlY3RhbmdsZSAxMjIiIHdpZHRoPSI2NC4xNTIiIGhlaWdodD0iNjQuMTUyIiByeD0iMyIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMCAxOS43MDcpIHJvdGF0ZSgtMTcuODkpIiBmaWxsPSJyZ2JhKDI1NSwyMjIsMTQwLDAuMikiLz4NCjwvc3ZnPg0K";